//#region src/kiosk_wifi_power_state.ts
var KioskWifiPowerState = /* @__PURE__ */ function(KioskWifiPowerState) {
	KioskWifiPowerState[KioskWifiPowerState["Unknown"] = 0] = "Unknown";
	KioskWifiPowerState[KioskWifiPowerState["On"] = 1] = "On";
	KioskWifiPowerState[KioskWifiPowerState["Off"] = 2] = "Off";
	return KioskWifiPowerState;
}(KioskWifiPowerState || {});
//#endregion
export { KioskWifiPowerState };

//# sourceMappingURL=kiosk_wifi_power_state.js.map